export default {
  groupTodo: 'To-dos',
  groupProject: 'Projects',
  groupAssets: 'Data assets',
  groupAccount: 'Account',
  groupPlatform: 'Platform',
  groupSysAdmin: 'System',
  groupUserSystem: 'System',
  groupFinance: 'Finance',
  groupAdmin: 'Administration',
  groupSuperAdmin: 'Super Admin',
  bizStats: 'Business analytics',
  todoTasks: 'Task inbox',
  photoLive: 'Photo Live',
  cloudSpace: 'Cloud storage',
  conference: 'Events',
  eventManage: 'Events',
  votingManage: 'Voting management',
  registrationManage: 'Questionnaires',
  venueManage: 'Seating setup',
  hotelManage: 'Hotels',
  receptionManage: 'Reception setup',
  donationManage: 'Donations',
  cardManage: 'Name cards',
  memberManage: 'Members',
  memberPlan: 'Membership plans',
  accountHub: 'Account',
  myMembership: 'My membership',
  memberPlanDetail: 'Plan details',
  memberPlanOrders: 'Purchase history',
  memberPlanActivations: 'Activations',
  companyPlanManage: 'Plan tiers',
  referralConfig: 'Referral settings',
  accountManage: 'Accounts',
  rechargePlan: 'Recharge plans',
  myRechargePacks: 'My packs',
  rechargeRecords: 'Recharge history',
  rechargeOverview: 'Recharge overview',
  rechargeResourceManage: 'Recharge pack catalog',
  myInvitations: 'My invitations',
  invitationConfig: 'Invitation settings',
  roleManage: 'Roles',
  permissionManage: 'Permissions',
  companyManage: 'Companies',
  userManage: 'Users',
  userVerificationConfig: 'Verification Settings',
  userVerificationReviews: 'Verification Reviews',
  userList: 'User list',
  resourceGrantManage: 'Resource grants',
  attendeeManage: 'Attendees',
  staffManage: 'Staff',
  orderRecords: 'Orders',
  assetManage: 'Finance & assets',
  messageNotifications: 'Notifications',
  personalCenter: 'Personal center'
}
